"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var todayCSS = function todayCSS(props) {
  if (!props.today) {
    return '';
  }
  return (0, _styledToken.default)('Button.tertiary.borderColor', function (borderColor) {
    return borderColor && "\n                &:not([aria-pressed=\"true\"]),\n                &:not([aria-pressed=\"true\"]):focus {\n                    border-color: " + borderColor + ";\n                }\n            ";
  })(props);
};

/** @class DatePickerButtonMixin */
/** @method */
/** CDS-2187: Extra specificity for SSR */
var DatePickerButtonMixin = function DatePickerButtonMixin(props) {
  return (0, _styledToken.default)({
    borderRadius: 'DatePickerButton.borderRadius',
    size: 'DatePickerButton.size',
    padding: 'DatePickerButton.padding',
    iconMargin: 'DatePickerButton.Icon.margin'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      size = _ref.size,
      iconMargin = _ref.iconMargin,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding;
    return (0, _styledComponents.css)(["&&&{border-radius:", ";height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", "px;", " &:disabled{text-decoration:line-through;}", "{margin:", ";}}"], borderRadius, size, size, padding, todayCSS(props), _Icon.StyledIcon, iconMargin);
  })(props);
};
exports.DatePickerButtonMixin = DatePickerButtonMixin;